import React from 'react';
import { useTranslation } from 'react-i18next';

function Services() {
  const { t } = useTranslation('about');
  const servicesData = t('services.items', { returnObjects: true });

  // Fallback image array for the services
  const serviceImages = [
    "/home1/assets/img/slider/1.jpg",
    "/home1/assets/img/slider/slideimg.jpg", 
    "/home1/assets/img/slider/5.jpg"
  ];

  // Safety check: ensure servicesData is an array
  const services = Array.isArray(servicesData) ? servicesData : [];

  return (
    <section className="tc-services-style7">
      <div className="container">
        <div className="content">
          <h2 className="fsz-60 text-center text-capitalize fw-400 mb-30 js-splittext-lines">
            {t('services.title')}
          </h2>
          <div className="cards">
            <div className="row">
              {services.map((item, i) => (
                <div key={i} className="col-lg-4">
                  <a
                    href="#"
                    className="service-card wow fadeInUp slow"
                    data-wow-delay="0.2s"
                  >
                    <div className="top-info" style={{ textAlign: 'center' }}>
                      <p className="fsz-14 text-uppercase">
                        {item.title}
                      </p>
                    </div>
                    <div className="img mb-60">
                      <img
                        src={serviceImages[i]}
                        alt={item.title}
                        className="img-cover"
                      />
                    </div>
                    <div className="text">{item.desc}</div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
